import HttpClient from '../../adapter/HttpClient';

export type Announcement = {
  id: string;
  url: string;
  title: string;
  start_at: string;
};

class AnnouncementWebApi {
  private httpClient: HttpClient;

  constructor({ httpClient }: { httpClient: HttpClient }) {
    this.httpClient = httpClient;
  }

  public getAnnouncements = async (): Promise<Array<Announcement>> => {
    const result = await this.httpClient.get(`/announcements`);

    return result.data.data;
  };
}

export default AnnouncementWebApi;
